import type { RunMetrics } from '@/models/agentRunReport'
import { formatCost, formatCount, formatLatency, formatPercent, formatTokens } from './format'

export interface MetricColumn {
  key: keyof RunMetrics
  label: string
  render: (metrics: RunMetrics) => string
  /** Shown under the value when it needs qualifying. */
  note?: (metrics: RunMetrics) => string | null
}

export const METRIC_COLUMNS: MetricColumn[] = [
  { key: 'runs', label: 'Runs', render: (m) => formatCount(m.runs) },
  {
    key: 'errorRate',
    label: 'Errors',
    render: (m) => formatPercent(m.errorRate),
    note: (m) => (m.errors ? formatCount(m.errors) : null),
  },
  { key: 'latencyP50Ms', label: 'p50', render: (m) => formatLatency(m.latencyP50Ms) },
  { key: 'latencyP95Ms', label: 'p95', render: (m) => formatLatency(m.latencyP95Ms) },
  { key: 'requestsPerRun', label: 'Req/run', render: (m) => m.requestsPerRun.toFixed(2) },
  { key: 'inputTokens', label: 'In', render: (m) => formatTokens(m.inputTokens) },
  { key: 'outputTokens', label: 'Out', render: (m) => formatTokens(m.outputTokens) },
  {
    key: 'cacheReadShare',
    label: 'Cached',
    render: (m) => (m.cacheReadTokens ? formatPercent(m.cacheReadShare, 0) : '—'),
  },
  {
    key: 'costUsd',
    label: 'Cost',
    render: (m) => formatCost(m.costUsd, m.pricedRuns),
    note: (m) => (m.unpricedRuns ? `${formatCount(m.unpricedRuns)} unpriced` : null),
  },
  {
    key: 'costPerRun',
    label: 'Cost/run',
    render: (m) => formatCost(m.costPerRun, m.pricedRuns),
  },
]
